import React from "react"

const LoaderIcon = ({ loaderIcon }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="196"
    height="115"
    viewBox="0 0 196 115"
    id="logo"
    ref={loaderIcon}
  >
    <g id="logo__group">
      <path
        id="logo__group__path"
        data-name="logo-path"
        fill="none"
        stroke="#06f"
        strokeWidth="1"
        d="M1207.474,242.017,1189.7,214.866,1171.86,187.76l-17.867-27.089-17.954-27.03-2.032-3.059-2.046,3.059-18.037,26.975-17.954,27.031-17.941,27.039L1060.81,240.8l-21.31.123-19.006.161,15.809-24.22,17.661-27.226,17.559-27.294L1080.3,148.7,1089,135l-9.3,13.3-9.228,13.348-18.441,26.706L1033.7,215.131l-18.262,26.825-1.971,2.9,3.536.03,22.5.191,22.5.13,1.167.007.666-.987,18.138-26.908,18.059-26.96,18.046-26.969,15.931-23.968,16,23.913,18.133,26.911,18.159,26.894,16.383,24.132-40.964.457L1143.6,211.159l-9.255-15.6L1125,180l8.658,15.945,8.745,15.9,17.5,31.788.347.631.755.008,45,.5,3.3.037Z"
        transform="translate(-1013.464 -130.582)"
      />
    </g>
  </svg>
)

export default LoaderIcon
